import axios from 'axios';
import api from "../api";
import moment from "moment";
moment.locale("pt-br");

async function size(params) {
  return new Promise((resolve, reject) => {
    params = {
      ...params,
      power: params.power * 1000,
    };

    axios.post(api.kit_sizer.size, params)
      .then(response => {
        let data = {
          ...response.data,
          power: response.data.power / 1000,
          products: response.data.products.map(product => {
            return {
              ...product,
              supply_date: !!product.supply_date ? moment(product.supply_date).format("DD/MM/YYYY") : null,
            };
          })
        };
        resolve(data);
      })
      .catch(error => {
        reject(error);
      });
  })
}

async function updateSizeProduct(product) {
  return new Promise((resolve, reject) => {
    axios.post(`${api.kit_sizer.kit_editor}/${product.optional_id}/update_product_quantity`, product)
      .then(response => {
        let r = {
          ...response,
          data: {
            ...response.data,
            products: response.data.products.map((product) => {
              return {
                ...product,
                supply_date: !!product.supply_date
                  ? moment(product.supply_date).format("DD/MM/YYYY")
                  : null,
              };
            }),
          }
        };
        resolve(r);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export default {
  size,
  updateSizeProduct
};

